<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md4 sm12 lg4 first-row>
        <material-card :key="dataLoaded">
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>New message</v-toolbar-title>
          </v-toolbar>
          <v-form ref="messageForm">
            <v-form-base
              v-bind:value="newMessage.data"
              v-bind:schema="newMessageSchema"
              :key="dataLoaded"
            />
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="primary" @click.stop="sendMessage()"
              >Send Message</v-btn
            >
          </v-form>
        </material-card>
      </v-flex>

      <v-flex md8 sm8 lg8>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Messages</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="messagesTable.headers"
            :items="messagesTable.data"
            :options.sync="messagesTable.options"
            :server-items-length="messagesTable.total"
            :loading="messagesTable.loading"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:item.name="{ item }">
              <router-link
                :to="{
                  name: 'campaigndetail',
                  params: { campaignId: item.campaign_id },
                }"
                >{{ item.name }}</router-link
              >
            </template>
            <template v-slot:item.date_created="{ item }">
              <td class="text-xs-right">
                {{ item.date_created | formatDate }}
              </td>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small @click="disassociateCampaign(item.campaign_id)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-dialog v-model="dialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Select Campaign</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px">
            <v-radio-group v-model="dialogm1" column>
              <v-radio
                v-for="campaign in campaignsList"
                :key="campaign.campaign_id"
                :label="campaign.name"
                :value="campaign.campaign_id"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn
              color="blue darken-1"
              text
              @click="
                associateCampaign(dialogm1);
                dialog = false;
              "
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import apiService from '../services'
import VFormBase from 'vuetify-form-base'
import { mapState } from 'vuex'
import moment from 'moment'

const formRules = {
  required: (field) => (v) => (v && v.length > 0) || `${field} is required`,
  requiredSelect: (field) => (v) => v || `${field} is required`,
  validEmail: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
}

export default {
  watch: {
    options: {
      handler () {
        this.getClient(this.$route.params.clientId)
      },
      deep: true
    }
  },
  components: { VFormBase },
  data () {
    return {
      dialog: false,
      dialogm1: '',
      formValid: true,
      rightDrawer: false,
      rightDrawerMerchant: false,
      editContact: false,
      dataLoaded: false, // Used to trigger form components re-rendering

      newMessage: {
        canBeEdited: false,
        data: {
          object: ''
        }
      },

      clientContacts: [],
      campaignsList: [],
      availableCampaignsList: [],

      // Messages table
      messagesTable: {
        headers: [
          { text: 'First name', value: 'first_name' },
          { text: 'Last name', value: 'last_name' },
          { text: 'Object', value: 'object' },
          { text: 'Date', value: 'date_creation' }
        ],
        data: [],
        total: 0,
        loading: true,
        options: {}
      }
    }
  },

  computed: {
    fullName () {
      return (
        this.legalRepresentative.first_name +
          ' ' +
          this.legalRepresentative.last_name || null
      )
    },

    orderedContacts () {
      return _.orderBy(this.clientContacts, 'contact_type_id')
    },

    // Add Notification service and auth service for UI Role control
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    newMessageSchema () {
      return {
        object: {
          type: 'text',
          label: 'Object',
          flex: 12,
          rules: [formRules.required('Object')]
        },
        message: {
          type: 'textarea',
          label: 'Message',
          flex: 12,
          rules: [formRules.required('Message')]
        }
      }
    }
  },

  mounted () {
    this.getMessages()
  },

  methods: {
    /**
     * Get entity messages
     */
    getMessages () {
      apiService
        .getMessages()
        .then((response) => {
          this.messagesTable.data = response
          this.messagesTable.total = response.length
          this.messagesTable.data.forEach(message => {
            message.date_creation = moment(message.date_creation).format('DD-MM-YYYY HH:mm')
          })
          console.log('Messages', this.messagesTable.data)
          this.messagesTable.loading = false
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Unable to get messages ${error}`
          })
          this.messagesTable.loading = false
        })
    },
    /**
     * Attachments
     */
    // Upload file su variabile del componente
    fileUpload () {
      console.log(this.$refs.file)
      this.file = this.$refs.file.lazyValue
    },

    // Upload del file su BE solo csv
    submitFile () {
      console.log('submitFile')
      let formData = new FormData()
      if (this.file.name) {
        console.log('Uploading CSV...')
        formData.append('file', this.file)
        formData.append('campaign_id', this.$route.params.campaignId)
        apiService.uploadCampaignRules(formData)
      }
    },

    sendMessage () {
      if (!this.$refs.messageForm.validate()) {
        return
      }
      const data = {
        object: this.newMessage.data.object,
        content: this.newMessage.data.message,
        entityId: this.loggedUser.merchant_id,
        creator: this.loggedUser.email
      }

      // Send message
      apiService
        .sendMessage(data)
        .then((response) => {
          // this.$store.dispatch('insert/message', {
          //   color: 'success',
          //   text: `Message sent succesfully`
          // })
          this.$refs.messageForm.reset()
          this.getMessages()
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `${error}`
          })
        })

      //
    }
  }
}
</script>
<style scoped>
/deep/ .v-text-field.name-part {
  max-width: 400px;
}
</style>
